

































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import request from '@/utils/request';
import AMSExpand from './AMSExpand';
import moment from 'moment';
import { AppStore } from '@/store/modules/app';
import AMSTooltip from '@/components/AMSTooltip.vue';
import utils, { stausDiableColor } from '@/utils/utils';

@Component({
  components: {
    'ams-expand': AMSExpand,
    'ams-tooltip': AMSTooltip
  }
})
export default class AMSTable extends Vue {
  @Prop({ type: Array, required: true, default: [] })
  headers!: ITableHeader[];
  @Prop({
    type: Array,
    default: () => {
      return new Array();
    }
  })
  value!: any[] | undefined;
  @Prop({ default: false }) isSelectAll!: boolean;
  @Prop({ default: false }) hasFooter!: boolean;
  @Prop({ default: null }) rowClickData: any;
  selected: Array<any> = [];
  constructor() {
    super();
  }
  items = this.value;
  isLoading = false;
  searchLoading = false;
  productSearch: string = '';
  search = '';
  getDBg(item: any, props: any) {
    //整行背景色 field条件字段
    if (item.bgColor && item.bgColor.type === 'nest') {
      if (this.getNestValue(props, item.bgColor && item.bgColor.field)) {
        return item.bgColor && item.bgColor.color;
      } else {
        return '';
      }
    } else {
      if (props[item.bgColor && item.bgColor.field]) {
        return item.bgColor && item.bgColor.color;
      } else {
        return '';
      }
    }
  }
  getDColor(item: any, props: any) {
    return utils.stausDiableColor(props[item.status]);
  }

  handleTrClick(tr: any) {
    if (!this.rowClickData) return;
    this.$router.push({ path: this.rowClickData.path, query: { [this.rowClickData.key]: tr[this.rowClickData.key] } });
  }
  getNestValue(item: any, keys: any) {
    let ret = '';
    const _keys = keys.split('.');
    let _item = item;
    let _key = _keys.shift();

    while (_key) {
      if (!_item) break;
      _item = ret = _item[_key];
      _key = _keys.shift();
    }

    return ret;
  }
  /**获取头部对齐样式 */
  getAlignStyle(item: any) {
    switch (item.align) {
      case 'left':
        return 'display:flex;justify-content:flex-start;';
      case 'right':
        return 'display:flex;justify-content:flex-end;';
      case 'center':
        return 'display:flex;justify-content:center;';
      default:
        return 'display:flex;justify-content:center;';
    }
  }

  sortUpClick(item: any) {
    if (item) {
      this.$emit('sort', item.value);
    }
  }
  sortDownClick(item: any) {
    if (item) {
      this.$emit('sort', `${item.value} desc`);
    }
  }
  filtedItem() {
    return this.items!.filter((i: any) => {
      return i.status !== 'Pass' && i.status !== 'NotPass' && i.status !== 'Ban' && i.status !== 'Cancel';
    });
  }
  toggleAll() {
    if (this.selected.length === this.filtedItem().length) this.selected = [];
    else this.selected = this.filtedItem();
    this.$emit('selectedAll', this.selected);
  }
  computedEdit(editItem: boolean | Function) {
    if (typeof editItem == 'function') {
      return editItem();
    } else {
      return editItem;
    }
  }
  computedDisable(item: boolean | Function, props: any) {
    if (typeof item == 'function') {
      return item(props);
    }
  }
  isShow(prop: any, index: number, btn?: any) {
    return btn.isShowBtn ? btn.isShowBtn(prop.item) : true;
  }
  isDisable(prop: any, btn?: any) {
    return btn.isDisabledBtn ? btn.isDisabledBtn(prop.item) : true;
  }

  getMax(index: number, keyName: string, type?: any) {
    if (type == 'isDiscountRate') {
      return 199;
    }
    if (type == 'isDiscountPrice') {
      return this.items![index]['orderPrice'] * 2 - 1;
    }
    if (type == 'stockQuantity') {
      return 999999999;
    }
    return Infinity;
  }

  getMin(index: number, keyName: string, type?: any) {
    if (type == 'isDiscountRate') {
      return 1;
    }
    if (type == 'isDiscountPrice') {
      return 1;
    }
    if (type == 'orderQuantity') {
      return 1;
    }
    if (type == 'materialsQuantity') {
      return 1;
    }
    return 0;
  }

  getType(type?: any) {
    if (type == 'isDiscountRate' || type == 'isDiscountPrice') {
      return 'text';
    }
    return 'number';
  }

  keyUpChange(event: any, index: number, keyName: string, type?: any) {
    let value = event.target.value;
    //折扣率 0<折扣率<200%，保留2位小数
    if (type == 'isDiscountRate') {
      // const reg = /^([1-9][0-9]*){1,2}(\.[0-9]{1,2})?$/;
      // if (value && !reg.test(value)) {
      //   if (value.indexOf('.') >= 0) {
      //     value = Number(value.split('.')[0].slice(0, value.length - 1) + '.' + value.split('.')[1].slice(0, 2));
      //   }
      // }
      // if (value && value < 1) {
      //   value = 1;
      // }
      // if (value && value >= 200) {
      //   value = value.slice(0, value.length - 1);
      // }

      if (value.indexOf('.') <= 0 && value.length > 1 && value.split('0').length - 1 === value.length) {
        value = '0';
      }

      //两位小数正则
      const reg = /^([1-9][0-9]*){1,2}(\.[0-9]{1,2})?$/;
      if (value && !reg.test(value)) {
        if (value.indexOf('.') >= 0) {
          let left = value.split('.')[0];
          left = /^[0-9]*$/.test(left) ? parseInt(left).toString() : '0';
          let right = value.split('.')[1];
          right = /^[0-9]*$/.test(right) ? (isNaN(parseInt(right)) ? '' : right.slice(0, 2)) : '';
          // console.log(right.length, 'right-length');
          right = right.length > 2 ? right.slice(0, 2) : right;
          // console.log(value, value.split('.'), left, right, '12412412412');
          value = left + '.' + right; //Number(left + '.' + right);
        } else {
          value = isNaN(parseInt(value)) ? '' : parseInt(value).toString();
          // console.log(value, '124124124');
        }
      }

      if (value && value >= 200) {
        if (value.indexOf('.') >= 0) {
          let left = value.split('.')[0];
          if (left >= 200) {
            value = 200 - 1;
          }
        } else {
          value = value.slice(0, value.length - 1);
        }
      }
    }
    //折扣价 0<折扣价<订货价*2，保留2位小数
    if (type == 'isDiscountPrice') {
      // const reg = /^([1-9][0-9]*)(\.[0-9]{1,2})?$/;
      // if (value == 0) {
      //   value = '';
      // } else if (value && !reg.test(value)) {
      //   if (value.indexOf('.') >= 0) {
      //     value = Number(value.split('.')[0] + '.' + value.split('.')[1].slice(0, 2));
      //   }
      // }

      // if (value && value >= this.items![index]['orderPrice'] * 2) {
      //   // value = this.items![index]['orderPrice'];
      //   value = value.slice(0, value.length - 1);
      // }

      if (value.indexOf('.') <= 0 && value.length > 1 && value.split('0').length - 1 === value.length) {
        value = '0';
      }

      const reg = /^([1-9][0-9]*)(\.[0-9]{1,2})?$/;
      if (value && !reg.test(value)) {
        if (value.indexOf('.') >= 0) {
          let left = value.split('.')[0];
          left = /^[0-9]*$/.test(left) ? parseInt(left).toString() : '0';
          let right = value.split('.')[1];
          right = /^[0-9]*$/.test(right) ? (isNaN(parseInt(right)) ? '' : right.slice(0, 2)) : '';
          right = right.length > 2 ? right.slice(0, 2) : right;
          value = left + '.' + right; //Number(left + '.' + right);
        } else {
          value = isNaN(parseInt(value)) ? '' : parseInt(value).toString();
          // console.log(value, '124124124');
        }
      }

      if (value && value >= this.items![index]['orderPrice'] * 2) {
        if (value.indexOf('.') >= 0) {
          let left = value.split('.')[0];
          if (left >= this.items![index]['orderPrice'] * 2) {
            value = this.items![index]['orderPrice'] * 2 - 1;
          }
        } else {
          value = value.slice(0, value.length - 1);
        }
      }
    }

    if (type == 'quantity') {
      if (value) {
        if (value < 0) {
          value = 0;
        } else if (value.indexOf('.') >= 0) {
          value = Number(value.split('.')[0]);
        } else if (value > Math.min(this.items![index]['stockQuantity'], this.items![index]['pendingAllocationQuantity'])) {
          value =
            Math.min(this.items![index]['stockQuantity'], this.items![index]['pendingAllocationQuantity']) < 0
              ? 0
              : Math.min(this.items![index]['stockQuantity'], this.items![index]['pendingAllocationQuantity']);
        }
      }
    }

    if (type == 'stockQuantity') {
      const numReg = /^([1-9][0-9]*)?$/;
      if (value) {
        if (value < 0) {
          value = 1;
        }
        if (String(value).length > 9) {
          value = Number(String(value).slice(0, 9));
        }
        if (!numReg.test(String(value))) {
          if (String(value).indexOf('.') > -1) {
            value = Number(String(value).split('.')[0]);
          } else {
            value = 1;
          }
        }
      }
    }

    this.items!.splice(index, 1, Object.assign({}, this.items![index], { [keyName]: value }));
    this.$emit('input', this.items);
  }
  blurInput(event: any, index: number, key: string, type: string) {
    let value = event.target.value;
    //折扣率 0<折扣率<200%，保留2位小数
    if (type == 'isDiscountRate') {
      if (value && value >= 200) {
        event.target.value = 199;
      }
    }

    //折扣价 0<折扣价<订货价*2，保留2位小数
    if (type == 'isDiscountPrice') {
      if (value && value >= this.items![index]['orderPrice'] * 2) {
        event.target.value = this.items![index]['orderPrice'] * 2 - 1;
      }
    }

    // 订单列单价
    if (type == 'disCount') {
      if (!event.target.value) {
        event.target.value = 0;
      }
      if (String(event.target.value).length > 9) {
        event.target.value = Number(String(event.target.value).slice(0, 9));
      }
    }
    // 订单列数量
    if (type == 'orderQuantity') {
      if (!event.target.value) {
        event.target.value = 1;
      }
      if (String(event.target.value).length > 5) {
        event.target.value = Number(String(event.target.value).slice(0, 5));
      }
    }
    if (type == 'stockQuantity') {
      if (!event.target.value) {
        event.target.value = 1;
      }
      if (String(event.target.value).length > 9) {
        event.target.value = Number(String(event.target.value).slice(0, 9));
      }
    }
    if (type == 'materialsQuantity') {
      if (!event.target.value) {
        event.target.value = 1;
      }
      if (String(event.target.value).length > 5) {
        event.target.value = Number(String(event.target.value).slice(0, 5));
      }
    }
    this.items![index][key] = event.target.value;
    this.$emit('input', this.items);
  }
  formatDate(date: Date) {
    return moment(date).format('YYYY-MM-DD');
  }
  formatDateTime(date: any) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }
  formatDateTimeMM(date: any) {
    return moment(date).format('YYYY-MM-DD HH:mm');
  }
  textInput(value: any, index: number, key: string, type: string) {
    // 订单列单价
    if (type == 'disCount') {
      const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;
      if (value) {
        if (value < 0) {
          value = 0;
        }
        if (!reg.test(String(value))) {
          if (String(value).indexOf('.') > -1) {
            value = Number(
              String(value).split('.')[0] +
                '.' +
                String(value)
                  .split('.')[1]
                  .slice(0, 2)
            );
          } else {
            value = 0;
          }
        }
        if (String(value).length > 9) {
          value = Number(String(value).slice(0, 9));
        }
      }
      this.items![index].price = Number(value) ? Number(value) : 0;
      this.items![index].totalPrice = Number((Number(value) * this.items![index].quantity).toFixed(2));
    }
    // 订单列数量
    if (type == 'orderQuantity') {
      const reg = /^([1-9][0-9]*)?$/;
      if (value) {
        if (value < 0) {
          value = 1;
        }
        if (String(value).length > 5) {
          value = Number(String(value).slice(0, 5));
        }
        if (!reg.test(String(value))) {
          if (String(value).indexOf('.') > -1) {
            value = Number(String(value).split('.')[0]);
          } else {
            value = 1;
          }
        }
      }
      this.items![index].quantity = value + '' == '' ? 1 : value;
      let num = this.items![index].totalPrice / this.items![index].quantity;
      this.items![index].price =
        String(num).indexOf('.') > -1 ? (this.items![index].totalPrice / this.items![index].quantity).toFixed(2) : this.items![index].totalPrice / this.items![index].quantity;
    }
    if (type == 'stockQuantity') {
      const numReg = /^([1-9][0-9]*)?$/;
      if (value) {
        if (value < 0) {
          value = 1;
        }
        if (String(value).length > 9) {
          value = Number(String(value).slice(0, 9));
        }
        if (!numReg.test(String(value))) {
          if (String(value).indexOf('.') > -1) {
            value = Number(String(value).split('.')[0]);
          } else {
            value = 1;
          }
        }
      }
      this.items![index].quantity = value + '' == '' ? 1 : value;
    }
    if (type == 'materialsQuantity') {
      const numReg = /^([1-9][0-9]*)?$/;
      if (value) {
        if (value < 0) {
          value = 1;
        }
        if (String(value).length > 5) {
          value = Number(String(value).slice(0, 5));
        }
        if (!numReg.test(String(value))) {
          if (String(value).indexOf('.') > -1) {
            value = Number(String(value).split('.')[0]);
          } else {
            value = 1;
          }
        }
      }
      this.items![index].quantity = value + '' == '' ? 1 : value;
    }
    // this.items![index][key] = value;
    this.items!.splice(index, 1, Object.assign({}, this.items![index], { [key]: value }));
    this.$emit('input', this.items);
  }
  queryMore(index: number, key: string) {
    this.$emit('queryMore', index, key);
  }
  add(index: number, key: string) {
    this.$emit('add', index, key);
  }
  remove(index: number, key: string) {
    this.$emit('remove', index, key);
  }
  clearSeleted() {
    this.selected = [];
  }
  btnClick(btn: any, row: any, key: string) {
    if (btn.routerName) {
      this.$router.push({
        name: btn.routerName,
        query: Object.assign({}, { id: row.item.id }, btn.query),
        params: btn.isParams ? Object.assign({}, row, btn.isParams) : null
      });
    }
    if (btn.callBack) {
      btn.callBack(btn, row, key);
    }
    this.$emit('btnClick', btn, row, key);
  }
  changeAll(props: any) {
    if (this.selected.length > 0 && this.selected.length === this.value!.length) {
      return true;
    } else {
      return false;
    }
  }
  formatPrice(num: number) {
    return utils.formatCurrencyPrice(num);
  }
  @Watch('selected')
  updateSelectedAll(val: any) {
    this.$emit('selectedAll', this.selected);
  }
  @Watch('value')
  valueUpdate(value: any) {
    this.items = value;
  }
}

export interface ITableHeader {
  text: string;
  value: string;
  align: string;
  sortable: boolean;
  class: string[] | string;
  width: string;
  edit: boolean;
  format: Function;
}
